import {useEffect, useState} from "react";
import {TQFont, TQInitParams, TQLogLevel, tqtypes, TQWeb} from "@coretech/typequestweb";
import {APP_ID} from "../utils/constants";
import useAppStore from "../stores/useAppStore";

export default function useTQWeb(): TQWeb | undefined {

    const [tqWeb, setTqWeb] = useState<TQWeb>();

    function makeId() {
        let result = "";
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        const charactersLength = characters.length;
        for (let i = 0; i < 24; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    useEffect(() => {
        const authParms = new tqtypes.AuthParams(
            APP_ID,
            `${makeId()}@AdobeID`,//"AEDF78945EC585780A495FE7@AdobeID",
            ""
        );
        authParms.isStaging = false;

        const init: TQInitParams = new TQInitParams(authParms);
        init.runtimeMode = tqtypes.RuntimeMode.ALL;
        init.appEntitlement = tqtypes.AppEntitlement.PAID;
        init.logLevel = TQLogLevel.DEBUG;
        init.fontFetchStrategy = tqtypes.FontFetchStrategy.ALL;
        init.applicationFontsCollectionType = [tqtypes.ApplicationFontsType.VARIABLE];
        init.statusUpdateCallback = (status: tqtypes.StatusCode, error: tqtypes.Error) => {
            //console.log(status)
            if (status === tqtypes.StatusCode.DONE) {
                console.log("[TQWeb]: initialized");
                setTimeout(() => useAppStore.setState({isInitialized: true}), 4000);
            } else if (status === tqtypes.StatusCode.ERROR_OCCURED) {
                console.error("[TQWeb]: " + tqtypes.ErrorCode[error.errCode] + " in initialization");
            }
            return true;
        };

        setTqWeb(new TQWeb(init));
    }, []);

    useEffect(() => {
        //console.log(tqWeb)
        if(tqWeb !== undefined) tqWeb.start();
    }, [tqWeb]);


    return tqWeb;
}